module.exports = __webpack_public_path__ + "static/media/depart_bus.cffd600f.svg";